import React, { useEffect, useState } from "react";
import axios from "axios";
import { API } from "@/auth";
import { Plus, Trash2, Loader2, ShieldCheck } from "lucide-react";

export default function HelloWhitelistManager() {
  const [items, setItems] = useState([]);
  const [form, setForm] = useState({ imei: "", model_hint: "", note: "" });
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState("");

  const load = async () => {
    const { data } = await axios.get(`${API}/hello-bypass/whitelist`);
    setItems(data);
  };
  useEffect(() => { load(); }, []);

  const add = async () => {
    setErr("");
    if (!/^\d{8,20}$/.test(form.imei.trim())) return setErr("IMEI invalide");
    setBusy(true);
    try {
      await axios.post(`${API}/hello-bypass/whitelist`, form);
      setForm({ imei: "", model_hint: "", note: "" });
      await load();
    } catch (e) { setErr(e.response?.data?.detail || "Erreur"); }
    finally { setBusy(false); }
  };

  const del = async (imei) => {
    if (!window.confirm(`Retirer ${imei} de la whitelist ?`)) return;
    await axios.delete(`${API}/hello-bypass/whitelist/${imei}`);
    load();
  };

  return (
    <div className="card-lhs p-5" data-testid="hello-whitelist-manager">
      <div className="flex items-center gap-2 mb-4">
        <ShieldCheck className="w-4 h-4 text-orange-500" />
        <h2 className="font-display font-bold uppercase tracking-wider text-sm">Whitelist Hello Bypass</h2>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-4 gap-2">
        <input className="input-lhs" placeholder="IMEI" value={form.imei}
          onChange={e => setForm(f => ({ ...f, imei: e.target.value.replace(/\D/g, "").slice(0, 20) }))}
          data-testid="hello-wl-imei" />
        <input className="input-lhs" placeholder="Modèle (iPhone 12)" value={form.model_hint}
          onChange={e => setForm(f => ({ ...f, model_hint: e.target.value }))} data-testid="hello-wl-model" />
        <input className="input-lhs" placeholder="Note (client X, contrat...)" value={form.note}
          onChange={e => setForm(f => ({ ...f, note: e.target.value }))} data-testid="hello-wl-note" />
        <button onClick={add} disabled={busy || !form.imei} className="btn-orange px-4 rounded-lg text-sm flex items-center justify-center gap-2"
          data-testid="hello-wl-add-btn">
          {busy ? <Loader2 className="w-4 h-4 animate-spin" /> : <Plus className="w-4 h-4" />} Autoriser
        </button>
      </div>
      {err && <div className="text-xs text-red-400 mt-2 font-mono-tech">{err}</div>}

      <div className="mt-4 max-h-96 overflow-y-auto scroll-thin space-y-2" data-testid="hello-wl-list">
        {items.map(w => (
          <div key={w.imei} className="flex items-center justify-between rounded-lg border border-zinc-800 bg-[#0C0C10] p-3 text-sm">
            <div className="min-w-0">
              <div className="font-mono-tech text-orange-400">{w.imei}</div>
              <div className="text-[11px] text-zinc-500 truncate">
                {w.model_hint || "—"} · {w.note || "—"} · ajouté par {w.added_by}
              </div>
              {w.used_at && <div className="text-[11px] text-emerald-400">Utilisé le {w.used_at.slice(0,10)} par {w.used_by}</div>}
            </div>
            <button onClick={() => del(w.imei)} className="text-zinc-500 hover:text-red-400" data-testid={`hello-wl-del-${w.imei}`}>
              <Trash2 className="w-4 h-4" />
            </button>
          </div>
        ))}
        {items.length === 0 && <div className="text-sm text-zinc-500 italic">Aucun IMEI autorisé.</div>}
      </div>
    </div>
  );
}
